import { Slot } from "expo-router";
import { Platform } from "react-native";

/**
 * Web-only layout for static pages (privacy policy, terms, guide, etc.)
 * This layout bypasses authentication and provides a clean web experience.
 * Individual pages/sub-layouts handle their own scrolling.
 */
export default function WebLayout() {
  if (Platform.OS !== "web") {
    return null;
  }

  return <Slot />;
}

